// extracted by mini-css-extract-plugin
export default {"counter":"u-Es2","viewCount":"VwobD","commentCount":"lFGC1","replyCount":"XjWOJ"};